module.exports = __webpack_public_path__ + "static/fleming-logo-152ad93985540fe95365a0da70982cfb.png";